import { render } from "./lampiran_ba.vue?vue&type=template&id=ee1c9580"
import script from "./lampiran_ba.vue?vue&type=script&lang=js"
export * from "./lampiran_ba.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__